import type { Core } from '@strapi/strapi'

const bootstrap = ({ strapi }: { strapi: Core.Strapi }) => {
  // bootstrap phase
}

export default bootstrap
